import type { IShopInventoryTotal } from '../redux/shop'

export function getStudioStockForProduct(studioInventory: IShopInventoryTotal[], productId: string): number {
  return studioInventory.find((item) => item.productId === productId)?.quantity ?? 0
}

export function canDeliverShopQuantity(
  studioInventory: IShopInventoryTotal[],
  productId: string,
  quantity: number,
): boolean {
  return getStudioStockForProduct(studioInventory, productId) >= quantity
}
